import { CheckEmail } from "./CheckEmail";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Logo } from "../components/Logo";

import * as S from "./styles";
import { useMediaQuery } from "usehooks-ts";
import { useTheme } from "styled-components";

export interface ForgotPasswordUserDataProps {
  initialEmail?: string;
}

export function ForgotPassword() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const initialEmail = searchParams.get("email") ?? "";

  const theme = useTheme();
  const isResponsive = useMediaQuery(
    `(max-width: ${theme.responsiveDesign.sm})`,
  );
  const navigate = useNavigate();

  return (
    <S.ForgotPasswordContainer>
      <S.ForgotPasswordContent>
        <S.ImageContainer
          title={t("goToHome")}
          onClick={() => navigate("/signin")}
        >
          <Logo {...(isResponsive && { width: "173", height: "70" })} />
        </S.ImageContainer>

        <CheckEmail initialEmail={initialEmail} />
      </S.ForgotPasswordContent>
    </S.ForgotPasswordContainer>
  );
}
